import { NgModule } from '@angular/core';
// import { NgxNewstickerAlbeModule } from 'ngx-newsticker-albe';
// import { NgxImageEditorModule } from 'ngx-image-editor';
import { NgxSummernoteModule } from 'ngx-summernote';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
  declarations: [],
  imports: [
    NgxDaterangepickerMd.forRoot(),
  ],
  exports: [
    // NgxNewstickerAlbeModule,
    //  NgxImageEditorModule,
    NgxSummernoteModule,
    NgxDropzoneModule,
    NgxDaterangepickerMd,
    ColorPickerModule
  ]
})
export class NgxUtilitiesModule { }
